import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-level-menu',
  templateUrl: './level-menu.component.html',
  styleUrls: ['./level-menu.component.scss']
})
export class LevelMenuComponent implements OnInit {

  @Input() levelMenu: any;
  @Output() isShowMenu = new EventEmitter<boolean>(false);
  public menuExpanded: boolean = false;

  constructor(
    private helpersServie: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.isOpenMenuOut();
  }

  public openMenu(): void {
    this.helpersServie.openLocalMenuBS.next(true);
  }

  private isOpenMenuOut(): void {
    if ((this.levelMenu[(this.levelMenu.length - 2)].subtree && this.levelMenu[(this.levelMenu.length - 2)].subtree.length > 1) || this.levelMenu[(this.levelMenu.length - 1)].subtree) {
      this.helpersServie.showLocalMenuBS.next(true);
    } else {
      this.helpersServie.showLocalMenuBS.next(false);
    }
  }

}
